module.exports = __webpack_public_path__ + "img/qzb_logo.9f853ee0.png";